import { ApiService } from '../apiService'
import type { ThemeDto, UserThemesResponse } from '../types/theme'

export const themesApi = {
  /** Fetch all themes the current user has access to (default + awarded) */
  getMyThemes: () => ApiService.get<UserThemesResponse>('/api/themes/my-themes'),

  /** Fetch a single theme by slug (if user has access) */
  getTheme: (slug: string) => ApiService.get<ThemeDto>(`/api/themes/${slug}`),
}
